import React, { Component } from "react";
import { Collapse, Container } from "reactstrap";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from 'react-redux';
import withRouter from "../Common/withRouter";
import {
    DATABASE_CLIENT_EDIT,
    DATABASE_CLIENT_FORM,
    DATABASE_CLIENT_PAGE,
    DATABASE_VEHICULE_EDIT,
    DATABASE_VEHICULE_FORM,
    DATABASE_VEHICULE_MANAGER_PAGE,
    DATABASE_VEHICULE_PAGE,
    ENCHERES_PAGE,
    FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
    FERRAILLEURS_MES_ACHATS_PAGE,
    FERRAILLEURS_TERMS_PAGE,
    MODULE_SELECTOR_PAGE,
    PRAMETRAGE_PAGE,
    RESEAU_PAGE,
    VHU_BID_OFFERS_PAGE,
    VHU_LOTS_PAGE,
    VVINAL_PAGE,
} from "../../routes/routeConstants";

const stripRouteParam = (path) => path.replace("/:id", "");

const moduleMenus = [
    {
        id: "vehicules",
        match: [DATABASE_VEHICULE_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_MANAGER_PAGE, stripRouteParam(DATABASE_VEHICULE_EDIT)],
        items: [
            { label: "Vehicules", icon: "ri-car-line", path: DATABASE_VEHICULE_PAGE, match: [DATABASE_VEHICULE_PAGE] },
            { label: "Créer vehicule", icon: "ri-add-circle-line", path: DATABASE_VEHICULE_MANAGER_PAGE, match: [DATABASE_VEHICULE_MANAGER_PAGE, DATABASE_VEHICULE_FORM] },
            { label: "Edition", icon: "ri-dashboard-2-line", path: DATABASE_VEHICULE_PAGE, match: [stripRouteParam(DATABASE_VEHICULE_EDIT)] },
        ],
    },
    {
        id: "clients",
        match: [DATABASE_CLIENT_PAGE, DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)],
        items: [
            { label: "Clients", icon: "ri-user-3-line", path: DATABASE_CLIENT_PAGE, match: [DATABASE_CLIENT_PAGE] },
            { label: "Nouveau client", icon: "ri-user-add-line", path: DATABASE_CLIENT_FORM, match: [DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)] },
        ],
    },
    {
        id: "vvinal",
        match: [VVINAL_PAGE],
        items: [
            { label: "Valeur venale", icon: "ri-currency-line", path: VVINAL_PAGE, match: [VVINAL_PAGE] },
        ],
    },
    {
        id: "parametrage",
        match: [PRAMETRAGE_PAGE],
        items: [
            { label: "Parametrage", icon: "ri-settings-line", path: PRAMETRAGE_PAGE, match: [PRAMETRAGE_PAGE] },
        ],
    },
    {
        id: "encheres",
        match: [ENCHERES_PAGE, VHU_LOTS_PAGE, VHU_BID_OFFERS_PAGE],
        items: [
            { label: "Lots VHU", icon: "ri-recycle-line", path: VHU_LOTS_PAGE, match: [VHU_LOTS_PAGE] },
            { label: "Offres VHU", icon: "ri-auction-line", path: VHU_BID_OFFERS_PAGE, match: [VHU_BID_OFFERS_PAGE] },
        ],
    },
    {
        id: "ferrailleurs",
        match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE, FERRAILLEURS_MES_ACHATS_PAGE, FERRAILLEURS_TERMS_PAGE],
        items: [
            { label: "Enchères visibles", icon: "ri-eye-line", path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE, match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE] },
            { label: "Mes achats", icon: "ri-shopping-bag-3-line", path: FERRAILLEURS_MES_ACHATS_PAGE, match: [FERRAILLEURS_MES_ACHATS_PAGE] },
            { label: "Termes & Conditions", icon: "ri-file-list-3-line", path: FERRAILLEURS_TERMS_PAGE, match: [FERRAILLEURS_TERMS_PAGE] },
        ],
    },
    {
        id: "reseau",
        match: [RESEAU_PAGE],
        items: [
            { label: "Groupes et férailleurs", icon: "ri-team-line", path: RESEAU_PAGE, match: [RESEAU_PAGE] },
        ],
    },
];

const matchesPath = (pathname, paths = []) => paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
const matchesMenuItem = (pathname, paths = []) => paths.some((path) => pathname === path || (path.endsWith("/edit") && pathname.startsWith(`${path}/`)));

const getCurrentModuleMenu = (pathname) => {
    return moduleMenus.find((module) => matchesPath(pathname, module.match)) || moduleMenus[0];
};

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({});
        }
    }

    componentDidMount() {
        var matchingMenuItem = null;
        var ul = document.getElementById("navigation");
        var items = ul.getElementsByTagName("a");
        for (var i = 0; i < items.length; ++i) {
            if (this.props.router.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;
        if (parent) {
            parent.classList.add("active"); // li
            const parent2 = parent.parentElement;
            parent2.classList.add("active"); // li
            const parent3 = parent2.parentElement;
            if (parent3) {
                parent3.classList.add("active"); // li
                const parent4 = parent3.parentElement;
                if (parent4) {
                    parent4.classList.add("active"); // li
                    const parent5 = parent4.parentElement;
                    if (parent5) {
                        parent5.classList.add("active"); // li
                        const parent6 = parent5.parentElement;
                        if (parent6) {
                            parent6.classList.add("active"); // li
                        }
                    }
                }
            }
        }
        return false;
    };

    render() {
        const pathname = this.props.router.location.pathname;
        const currentModule = getCurrentModuleMenu(pathname);

        return (
            <React.Fragment>
                <div className="topnav topnav-enhanced">
                    <Container fluid>
                        <nav className="navbar navbar-light navbar-expand-lg topnav-menu topnav-menu-enhanced" id="navigation">

                            <Collapse isOpen={this.props.menuOpen} className="navbar-collapse navbar-collapse-enhanced" id="topnav-menu-content">
                                <ul className="navbar-nav navbar-nav-enhanced">

                                    <li className="nav-item nav-item-enhanced">
                                        <Link className="nav-link nav-link-enhanced" to={MODULE_SELECTOR_PAGE}>
                                            <i className="ri-arrow-left-line me-2 nav-icon"></i>
                                            <span className="nav-label">Retour aux modules</span>
                                        </Link>
                                    </li>

                                    {currentModule.items.map((item) => {
                                        const isActive = matchesMenuItem(pathname, item.match);
                                        return (
                                            <li className="nav-item nav-item-enhanced" key={item.path}>
                                                <Link className={`nav-link nav-link-enhanced${isActive ? " active" : ""}`} to={item.path}>
                                                    <i className={`${item.icon} me-2 nav-icon`}></i>
                                                    <span className="nav-label">{item.label}</span>
                                                </Link>
                                            </li>
                                        );
                                    })}

                                    
                                </ul>
                            </Collapse>
                        </nav>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { leftSideBarType, leftSideBarTheme } = state.Layout;
    return { leftSideBarType, leftSideBarTheme };
}

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(Navbar)));
